import { cn } from "@/lib/utils";

interface FormContainerProps {
  children: React.ReactNode;
  className?: string;
  variant?: "page" | "modal";
}

export function FormContainer({ children, className, variant = "page" }: FormContainerProps) {
  const variantClasses = {
    page: "",
    modal: "rounded-lg shadow-xl",
  };

  return <div className={cn(variantClasses[variant], className)}>{children}</div>;
}
